import { CMSBlocksState } from "../cmsPage.state"

export const hideTemplatePartial = (partial: 'header' | 'footer' | 'footer-share' | 'donation', state: CMSBlocksState) => {
  // 404 PAGE EXCEPTION
  if (partial != 'footer-share' && (state.loader.kind === "failed" || state.loader.kind === "unloaded")) return false
  if (partial == 'footer-share' && (state.loader.kind === "failed" || state.loader.kind === "unloaded")) return true

  if (state.loader.kind === "loaded") {
    // HOME PAGE EXCEPTION
    if (partial == 'footer-share' && state.loader.value.pageData.page.kind === "homepage") return true
    // CAMPAIGN PAGE EXCEPTION
    if (state.loader.value.pageData.page.kind === "campaign") return true

    if (partial == 'donation' && state.loader.value.pageData.header.hideDonationButton === true) return true;

    if (partial == 'header' && state.loader.value.pageData.header.hideHeader === true) return true;
  }
  
  return false
}
